import { render, staticRenderFns } from "./AttributesModal.vue?vue&type=template&id=c625bfd8"
import script from "./AttributesModal.vue?vue&type=script&lang=js"
export * from "./AttributesModal.vue?vue&type=script&lang=js"
import style0 from "./AttributesModal.vue?vue&type=style&index=0&id=c625bfd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports